export const GOOGLE_AUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;
export const GRAPHQL_URI = `${process.env.REACT_APP_API_DOMAIN}/graphql`;
export const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;
export const DOMAIN_NAME = process.env.REACT_APP_DOMAIN_NAME;
export const USER_ONBOARDING_SUBDOMAIN = 'login';
